import { DEPENDENCIES } from '@empathy/search-adapter';
import { BeaconTrackingRequestor } from '@empathyco/x-adapter';
import { CdlFilterMapper } from '../adapters/cdl-filter.mapper';
import { CdlIdentifierResultMapper } from '../adapters/cdl-identifier-result.mapper';
import { CdlPriceTransformed } from '../adapters/cdl-price-service.transformer';
import { CdlResultMapper } from '../adapters/cdl-result.mapper';
import { mapResultTagging } from '../adapters/cdl-tagging-result.mapper';
import { UseEmpathyAdapterOptions } from '../config/adapter.configurator';

export const ADAPTER_CONFIG: UseEmpathyAdapterOptions = {
  configureAdapter: builder =>
    builder
      .addMapper(mapResultTagging, 'queryTagging')
      .addClassMapper(CdlFilterMapper, 'filters')
      .addClassMapper(CdlResultMapper, 'results')
      .addClassMapper(CdlIdentifierResultMapper, 'results', 'searchById')
      .onResponseTransformed(CdlPriceTransformed, 'search')
      .configureContainer(container => {
        container.rebind(DEPENDENCIES.Requestors.track).to(BeaconTrackingRequestor);
      })
      .onBeforeRequest(({ request }) => {
        delete request.user;
        delete request.user_type;
      })
};
